export default "__VITE_ASSET__BB6bO5IB__"